import { useMutation, UseMutationResult } from "@tanstack/react-query";
import { ChatPayload, ChatResponse, sendChatMessage } from "./callbacks";
import { TResponse } from "../../../types/common";

export const useAiAgentChat = (
  {
    onSuccess,
    onError,
  }: {
    onSuccess?: (res: TResponse<ChatResponse>) => void;
    onError?: (error: unknown) => void;
  } = {}
): UseMutationResult<TResponse<ChatResponse>, unknown, ChatPayload> => {
  return useMutation<TResponse<ChatResponse>, unknown, ChatPayload>({
    mutationFn: async (data) => {
      const res = await sendChatMessage(data);
      return res.data;
    },
    onSuccess: (res) => {
      onSuccess?.(res);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};
